module.exports = __webpack_public_path__ + "img/FCHS_ER_2023-3.c596f7bd.jpg";